import GenieLoader from "@/components/ui/GenieLoader";

/**
 * Full-screen loader shown while a new Genie is being created.
 * Delegates to the standardised <GenieLoader> with creation-flavoured copy.
 */
const CREATION_MESSAGES = [
  "Summoning your Genie…",
  "Shaping its personality…",
  "Tuning its voice…",
  "Bringing it to life…",
  "Almost ready…",
];

export const GenieCreationLoader = () => (
  <GenieLoader size="fullscreen" messages={CREATION_MESSAGES} />
);

export default GenieCreationLoader;
